export const SELECT_TYPE = {
  relation: ["지인", "친구", "동료", "가족"],
  font: ["Noto Sans", "Pretendard", "나눔명조", "나눔손글씨 손편지체"],
};
